//@flow
import React from 'react';
import { RichText } from 'prismic-reactjs';
import { PrismicAwardEligibility } from '../../types/prismic';
import styles from './grantEligibility.module.scss';
import Link from 'next/link';
import { TwoImagesWithBlob, WavyBox } from '../base';
import { Colors } from '../../helpers/constants';

type Props = PrismicAwardEligibility;

const GrantEligibility = ({ data }: Props) => {
  const {
    award_process_active,
    eligibility_header,
    eligibility_criteria,
    selection_header,
    selection_criteria,
    eligibility_image_one,
    eligibility_image_two,
    eligibility_cta_link_url,
    eligibility_cta_link_text,
  } = data;

  return (
    <>
      <WavyBox className="bg-pink-tan column center">
        <article className={`inner-width inner-width-padding`}>
          <div className={styles.eligibility}>
            <div>
              <RichText render={eligibility_header} />
              <ul className={styles.criteria}>
                {eligibility_criteria.map((item, index) => {
                  return <li key={index}>{item.text}</li>;
                })}
              </ul>
              {selection_header && selection_criteria && (
                <>
                  <RichText render={selection_header} />
                  <ul className={styles.criteria}>
                    {selection_criteria.map((item, index) => {
                      return <li key={index}>{item.text}</li>;
                    })}
                  </ul>
                </>
              )}
              {award_process_active && (
                <Link href={eligibility_cta_link_url[0].text}>
                  <a className="button secondary no-arrow invert">
                    {eligibility_cta_link_text[0].text}
                  </a>
                </Link>
              )}
            </div>
            <div className={styles.criteraImage}>
              <TwoImagesWithBlob fillColor={Colors.WHITE_ANTIQUE}>
                {({ imgOne, imgTwo }) => (
                  <>
                    <img
                      className={imgOne}
                      src={eligibility_image_one.url}
                      alt={eligibility_image_one.alt}
                    />
                    <img
                      className={imgTwo}
                      src={eligibility_image_two.url}
                      alt={eligibility_image_two.alt}
                    />
                  </>
                )}
              </TwoImagesWithBlob>
            </div>
          </div>
        </article>
      </WavyBox>
    </>
  );
};

export default GrantEligibility;
